import { Component } from '@angular/core';
import { ChartDataset } from 'chart.js';
import { GRAPH_PANEL_IMPORTS, GraphPanelComponent } from 'src/app/panels/components/graph-panel/graph-panel.component';
import { PanelComponent } from 'src/app/panels/components/panel.component';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { GenerateGraphDataset, GraphType, IGraphConfig, IGraphMappedDataset } from 'src/app/panels/models/graph';
import { PanelType } from 'src/app/panels/models/panel-type';
import { Color } from 'src/app/shared/services/color/colors';

@PanelComponent.register
@Component({
  templateUrl: '../../../../panels/components/graph-panel/graph-panel.component.html',
  styleUrl: '../../../../panels/components/graph-panel/graph-panel.component.scss',
  selector: 'app-wind-speed-graph-panel',
  imports: GRAPH_PANEL_IMPORTS,
})
export class WindSpeedGraphPanelComponent extends GraphPanelComponent {
  public static override readonly type = PanelType.WindSpeedGraph;
  public override unit = DisplayUnit.MetersPerSecond;

  public override config: IGraphConfig = { getGraphTypeDataset: this.getGraphTypeDataset };

  private getGraphTypeDataset(
    generateDataset: GenerateGraphDataset,
    dataset: IGraphMappedDataset,
    startTimestamps: string[],
    endTimestamps: string[],
  ): ChartDataset {
    switch (dataset.type) {
      case GraphType.ClimateWindSpeed:
        return generateDataset(
          dataset,
          startTimestamps,
          endTimestamps,
          'Windsnelheid',
          Color.BrightBlue,
          DisplayUnit.MetersPerSecond,
          'line',
          undefined,
        );
      default:
        throw new Error(`No dataset specified for GraphType '${dataset.type}'`);
    }
  }
}
